import React from "react";
import "../../assets/css/seller-info.css";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Seller_sidebar from "./Seller-sidebar/Seller_sidebar";
import Seller_tabs_list from "./Seller-sidebar/Seller_tabs_list";
import {
	cat12,
	detail_order_img,
	product_inventory,
	star,
} from "../../constants";
import SellerHeader from "../../components/SellerHeader/SellerHeader";
import SellerFooter from "../../components/SellerFooter/SellerFooter";

const Seller_info = () => {
	return (
		<>
			{/* Header starts here */}
			<SellerHeader />
			{/* Header ends here */}
			<section className="dashboard">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<Seller_sidebar />
						</div>
						<div className="col-lg-8 refunr-ore pus">
							<Seller_tabs_list />
							<div className="seller-info-wrapper">
								<div className="edit-head-wrapper">
									<h6>Add Personal Info</h6>
								</div>
								<div className="profile-row-wrapper">
									<div className="profile-img-wrappper">
										<img src={cat12} alt="" />
										<div className="profile-upload-wrapper">
											<h6>Jpeg or Png maximum size (5mb)</h6>
											<button className="btn">Browse image</button>
										</div>
									</div>
									<div className="processing-wrapper">
										<h5>Processing</h5>
										<i className="fa fa-spinner" aria-hidden="true"></i>
									</div>
								</div>
								<div className="info-form-wrappe">
									<form action="">
										<div className="form-group row">
											<div className="col-lg-5">
												<label htmlFor="First Name:">First Name</label>
												<input
													type="text"
													className="form-control"
													placeholder="John"
												/>
											</div>
											<div className="col-lg-2  px-0"></div>
											<div className="col-lg-5">
												<label htmlFor="First Name:">Last Name</label>
												<input
													type="text"
													className="form-control"
													placeholder="Doe"
												/>
											</div>
										</div>
										<div className="form-group row">
											<div className="col-lg-4">
												<label htmlFor="First Name:">Age</label>
												<input
													type="text"
													className="form-control"
													placeholder="24"
												/>
											</div>
											<div className="col-lg-4">
												<label htmlFor="First Name:">City</label>
												<input
													type="text"
													className="form-control"
													placeholder="Lorem ipsum"
												/>
											</div>
											<div className="col-lg-4">
												<label htmlFor="First Name:">Country</label>
												<input
													type="text"
													className="form-control"
													placeholder="Lorem ipsum"
												/>
											</div>
										</div>
										<div className="form-group row">
											<div className="col-lg-5">
												<label htmlFor="First Name:">Phone</label>
												<input
													type="text"
													className="form-control"
													placeholder="12-345-67890"
												/>
											</div>
											<div className="col-lg-2 px-0"></div>
											<div className="col-lg-5">
												<label htmlFor="First Name:">Email</label>
												<input
													type="text"
													className="form-control"
													placeholder="john@examplecom"
												/>
											</div>
										</div>
										<div className="form-group row">
											<div className="col-lg-4">
												<label htmlFor="First Name:">
													Company / Business name
												</label>
												<input
													type="text"
													className="form-control"
													placeholder="Apricot"
												/>
											</div>
											<div className="col-lg-4">
												<label htmlFor="First Name:">Business Type</label>
												<input
													type="text"
													className="form-control"
													placeholder="Seller"
													readOnly
													value="Seller"
												/>
											</div>
											<div className="col-lg-4">
												<label htmlFor="First Name:">Designation</label>
												<input
													type="text"
													className="form-control"
													placeholder="
													Sales manager"
												/>
											</div>
										</div>
										<div
											className="form-group row"
											style={{ marginTop: "40px" }}
										>
											<div className="col-lg-8">
												<div className="form-check">
													<input
														className="form-check-input"
														type="checkbox"
														value=""
														id="flexCheckDefault"
													/>
													<label
														className="form-check-label"
														for="flexCheckDefault"
													>
														Lorem ipsum dolor sit amet, consetetur sadipscing
														elitr,
													</label>
												</div>
											</div>
											<div className="col-lg-4">
												<div className="btn-wrap text-end">
													<button className="btn">Save Changes</button>
												</div>
											</div>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* Footer starts here */}
			<SellerFooter />
			{/* Footer ends here */}
		</>
	);
};

export default Seller_info;
